import React from 'react';
import { useSiteSettings } from '../context/SiteSettingsContext';
import { useTheme } from '../context/ThemeContext';

export default function InspiraFooter({ categories = [], onCategoryClick }) {
  const { settings } = useSiteSettings();
  const { theme } = useTheme();
  const currentYear = new Date().getFullYear();
  const logoSrc = (theme === 'dark' && settings.logoFooterDarkUrl)
    ? settings.logoFooterDarkUrl
    : (settings.logoFooterUrl || settings.logoDarkUrl || settings.logoUrl || '/logo-inspira-white.png');
  const logoFooterSize = settings.logoFooterSize || 44;

  return (
    <footer className="inspira-footer">
      <div className="inspira-footer-inner">
        {/* Brand */}
        <div className="inspira-footer-brand">
          <div style={{ marginBottom: 14 }}>
            <img
              src={logoSrc}
              alt={settings.siteName}
              style={{ height: logoFooterSize, objectFit: 'contain' }}
              onError={e => { e.target.style.display = 'none'; }}
            />
          </div>
          <p>{settings.footerTagline}</p>
          {(settings.externalLinks || []).length > 0 && (
            <div style={{ marginTop: 16, display: 'flex', gap: 10, flexWrap: 'wrap' }}>
              {settings.externalLinks.map(l => (
                <a key={l.url} href={l.url} target="_blank" rel="noopener noreferrer"
                  style={{ fontSize: 12, color: 'rgba(255,255,255,0.55)', textDecoration: 'underline' }}>
                  {l.label}
                </a>
              ))}
            </div>
          )}
        </div>

        {/* Topik */}
        <div className="inspira-footer-col">
          <h4>Topik</h4>
          {categories.slice(0, 6).map(cat => (
            <button key={cat._id} onClick={() => onCategoryClick?.(cat._id)}>
              {cat.name}
            </button>
          ))}
          {categories.length === 0 && (
            <>
              <span style={{ fontSize: 13, color: 'rgba(255,255,255,0.45)' }}>Teknologi</span>
              <span style={{ fontSize: 13, color: 'rgba(255,255,255,0.45)' }}>Industri</span>
              <span style={{ fontSize: 13, color: 'rgba(255,255,255,0.45)' }}>Akademik</span>
              <span style={{ fontSize: 13, color: 'rgba(255,255,255,0.45)' }}>Pengabdian</span>
            </>
          )}
        </div>

        {/* Platform */}
        <div className="inspira-footer-col">
          <h4>Platform</h4>
          <a href="/login">Masuk</a>
          <a href="/register">Daftar</a>
          <a href="/publikasi">Kirim Artikel</a>
          <a href="/dashboard">Dashboard</a>
          {(settings.footerLinks || []).map(l => (
            <a key={l.url} href={l.url} target="_blank" rel="noopener noreferrer">{l.label}</a>
          ))}
        </div>

        {/* Kontak */}
        <div className="inspira-footer-col">
          <h4>Kontak</h4>
          {settings.contactEmail && (
            <a href={`mailto:${settings.contactEmail}`}>{settings.contactEmail}</a>
          )}
          {(settings.externalLinks || []).map(l => (
            <a key={l.url} href={l.url} target="_blank" rel="noopener noreferrer">{l.label}</a>
          ))}
          {(settings.socialLinks || []).map(l => (
            <a key={l.url} href={l.url} target="_blank" rel="noopener noreferrer">{l.label}</a>
          ))}
        </div>
      </div>

      {/* Bottom bar */}
      <div className="inspira-footer-bottom">
        <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
          <img
            src={logoSrc}
            alt={settings.siteName}
            style={{ height: 28, objectFit: 'contain' }}
            onError={e => { e.target.style.display = 'none'; }}
          />
          <p>© {currentYear} {settings.copyrightText}. Hak cipta dilindungi.</p>
        </div>
        <p>{settings.siteName} · {settings.siteTagline}</p>
      </div>
    </footer>
  );
}
